<template>
  <div class="customer-edit-appointments">
    <agenda-show-appointment @submit="loadAppointments" ref="showapp" locked="true"></agenda-show-appointment>
    <customer-send-enroll ref="enroll" :customer="customer"></customer-send-enroll>

    <div v-if="is_core" class="customer-next-appointment">
      <div class="row form-group">
        <div class="col">
          <h4>PRÓXIMA CITA</h4>
          <small>Rellena estos datos para orientar a Recepción de cara a la próxima cita</small>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-2">
          <input type="date" class="form-control" v-model="next_appointment.date" id="next_app_date">
          <label for="next_app_date" class="wabident-info">Fecha recomendada</label>
        </div>
        <div class="col-sm-2">
          <select v-model="next_appointment.doctor_id" class="custom-select" id="next_app_doctor">
            <option :value="null">Elige profesional...</option>
            <option :value="i" v-for="(doctor, i) in doctor_names" :key="i">
              {{ doctor }}
            </option>
          </select>
          <label for="next_app_doctor" class="wabident-info">Profesional asignado</label>
        </div>
        <div class="col-sm-4">
          <select v-model="next_appointment.treatment_id" class="custom-select" id="next_app_treatment">
            <option :value="null">Elige tratamiento...</option>
            <option :value="treatment.id" v-for="(treatment, i) in pending_treatments" :key="i">
              {{ treatment.product.name }}
            </option>
          </select>
          <label for="next_app_treatment" class="wabident-info">Tratamiento</label>
        </div>
        <div class="col-sm-1">
          <input type="number" class="form-control" v-model="next_appointment.duration" id="next_app_duration">
          <label for="next_app_duration" class="wabident-info">Duración aprox.</label>
        </div>
        <div class="col-sm-3">
          <button @click="clearNextAppointment" type="button" class="btn btn-wabident ml-2">
            Borrar <i class="fas fa-trash"></i>
          </button>
          <button @click="saveNextAppointment" type="button" class="btn btn-wabident ml-2">
            Guardar <i class="fas fa-save"></i>
          </button>
        </div>
      </div>

      <div class="row form-group">
        <div class="col">
          <h4>CITAS</h4>
        </div>
      </div>
    </div>

    <div class="row customer-edit-appointments__header">
      <div class="
                            col
                            text-center
                            d-flex
                            justify-content-between
                            align-items-center
                          ">
        <button :disabled="agenda_restricted" @click="newAppointment" type="button"
          class="btn btn-primary btn-wabident">
          Nueva Cita <i class="fa fa-plus ml-3"></i>
        </button>
        <div class="d-flex gap-10">
          <button @click="sendPending" type="button" class="btn btn-primary btn-wabident">
            Enviar Pendientes <i class="fab fa-whatsapp ml-3"></i>
          </button>
          <button v-if="can_enroll" @click="sendEnroll" type="button" class="btn btn-primary btn-wabident">
            Recordatorio Twilio
          </button>
        </div>
      </div>
    </div>

    <div class="row">

      <div class="col d-flex align-items-center">
        <div class="form-check form-check-inline mb-2">
          <input v-model="show_deleted" class="form-check-input" type="checkbox" id="show_deleted" />
          <label class="form-check-label" for="show_deleted">Mostrar citas borradas
          </label>
        </div>
        <div class="form-check form-check-inline mb-2" v-if="show_clinics_checkbox">
          <input v-model="show_all_clinics" class="form-check-input" type="checkbox" id="show_all_clinics" />
          <label class="form-check-label" for="show_all_clinics">Mostrar citas de todas las clínicas
          </label>
        </div>
      </div>

    </div>

    <div class="customer-edit-appointments-list">
      <div v-for="(appoint, index) in filtered_appointments" :key="index" class="row">
        <div class="col">
          <div :class="appointmentClass(appoint)">
            <button type="button" class="btn btn-wabident-status float-right" :disabled="!isCurrentClinic(appoint)"
              @click="editAppointment(appoint)" :class="appointmentBtnClass(appoint)"
              style="margin-top: 10px; min-width: 136px">
              {{ appointmentBtnText(appoint) }}
            </button>
            <label><strong>Fecha:</strong> {{ appointmentDate(appoint) }}</label>
            <label><strong>Hora:</strong> {{ appointmentTime(appoint) }}</label>
            <label><strong>En:</strong> {{ appointmentClinic(appoint) }}</label>
            <label v-if="appoint.doctor_id">
              <strong>Con: </strong>
              {{ doctor_names[appoint.doctor_id] }}
            </label>
            <p>
              <strong v-if="appoint.deleted_at">BORRADA</strong>
              <span v-if="appoint.is_first">
                <strong>1ª Cita</strong>
                <span v-if="appoint.product_category_id">
                  - {{ category_names[appoint.product_category_id] }}
                </span>
                <br>
              </span>
              <span v-if="appoint.treatments && appoint.treatments.length">
                <strong>Ttos:</strong> <span v-for="(treatment, index) in appoint.treatments" :key="index">
                  {{ treatment.product.name }}.
                </span>
                <br>
              </span>
              <span v-if="appoint.notes && appoint.notes != ''">
                <strong>Notas:</strong> {{ appoint.notes }}
              </span>
              <span v-if="appoint.documents && appoint.documents.length"
                class="d-flex justify-content-start align-items-center">
                <a :href="`/customer/${customer.id}/document/${document.id}/view`" target="_blank"
                  class="customer-edit-appointment__document text-center" v-for="document in appoint.documents"
                  :key="document.id">
                  <i class="fas fa-file"></i>
                  <small>{{ document.title }}</small>
                </a>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customer: { required: true },
  },
  data() {
    return {
      show_deleted: false,
      show_all_clinics: true,
      appointments: [],
      clinics: [],
      next_appointment: {},
      pending_treatments: [],
      box_to_clinic: {},
      is_loading: false,
    };
  },
  computed: {
    can_enroll() {
      return this.clinic &&
        this.clinic.config &&
        this.clinic.config.appointments_twilio_messaging &&
        this.clinic.config.appointments_twilio_enroll_template &&
        this.clinic.config.appointments_twilio_enroll_template != '';
    },
    show_clinics_checkbox() {
      return this.clinics.length > 1;
    },
    filtered_appointments() {
      return this.appointments.filter((a) => {
        if (!this.show_deleted && a.deleted_at !== null) {
          return false;
        }

        const clinic = this.box_to_clinic[a.box_id];
        if (clinic) {
          if (!this.show_all_clinics && (this.clinic.id != clinic.id)) {
            return false;
          }
        }


        return true;
      })
    },
    agenda_restricted() {
      return this.user_capabilities.agenda_restricted;
    },
    doctor_names() {
      let ret = {};
      if (!this.clinic && !this.clinic.doctors) return ret;

      this.clinic.doctors.forEach((d) => {
        ret[d.doctor.id] = d.name;
      });

      return ret;
    },
    category_names() {
      let ret = {};
      if (!this.clinic && !this.clinic.product_categories) return ret;
      this.clinic.product_categories.forEach((cat) => {
        ret[cat.id] = cat.name;
      });
      return ret;
    },
    pending_msg_header() {
      if (!this.clinic) return "";

      if (this.clinic.config["custom_pending_message_header"]) {
        return this.clinic.config["custom_pending_message_header"] + "\n";
      }

      return `Recordatorio de citas programadas:\n`;
    },
    pending_msg_footer() {
      if (!this.clinic) return "";

      if (this.clinic.config["custom_pending_message_footer"]) {
        return "\n" + this.clinic.config["custom_pending_message_footer"];
      }

      return "\nReciba un cordial saludo.";
    },
    ...mapGetters(["errorwindow", "msgwindow", "clinic", "is_core", 'user_capabilities']),
  },
  methods: {
    getTreatmentName(treatment_id) {
      for (const i in this.pending_treatments) {
        let t = this.pending_treatments[i];
        if (t.id == treatment_id) {
          return t.product.name;
        }
      }
    },
    saveNextAppointment() {
      if (!this.is_loading) {
        this.is_loading = true;
        this.next_appointment.treatment_name = this.getTreatmentName(this.next_appointment.treatment_id);
        let params = {
          next_appointment: this.next_appointment
        };

        axios
          .post(`/customer/${this.customer.id}/next_appointment`, params)
          .then((response) => {
            this.msgwindow.success('Actualizada próxima cita');
          })
          .catch((error) => {
            console.log("[ERR] loadAppointments ", error);
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    clearNextAppointment() {
      if (!this.is_loading) {
        this.next_appointment.date = null;
        this.next_appointment.doctor_id = null;
        this.next_appointment.treatment_id = null;
        this.next_appointment.treatment_name = null;
        this.next_appointment.duration = null;
        this.saveNextAppointment();
      };
    },
    isCurrentClinic(app) {
      if (!this.clinic) return false;
      let box = this.clinic.boxes.find((x) => x.id == app.box_id);
      return Boolean(box);
    },
    appointmentClass(appoint) {
      let ret = {
        "customer-edit-appointment": true,
      };

      let status = appoint.status;
      if (!status || status.length == 0) status = "pending";

      ret[status] = true;
      ret["other-clinic"] = !this.isCurrentClinic(appoint);
      return ret;
    },
    appointmentDate(app) {
      return moment(app.date_from).toDate().toLocaleDateString();
    },
    appointmentTime(app) {
      return moment(app.date_from).format("HH:mm");
    },
    appointmentClinic(app) {
      let clinic = this.box_to_clinic[app.box_id];
      if (!clinic) return "Sin clínica!";
      return clinic.name;
    },
    appointmentBtnClass(app) {
      let ret = {};
      let status = app.status;
      if (!status || status.length == 0) status = "pending";
      ret[status] = true;
      return ret;
    },
    appointmentBtnText(app) {
      var now = moment();
      var then = moment(app.date_from);
      var diff = then.diff(now, "days");

      if (diff > 0) {
        return `FALTAN ${diff} DÍAS`;
      }

      let status = app.status;
      if (!status || status.length == 0) {
        status = "pending";
      }

      if (status == 'pending' && diff < 0) {
        return 'FALLIDA';
      }

      return WabiDent.AppointmentStatus[status];
    },
    mapBoxesToClinics(clinics) {
      let ret = {};
      clinics.forEach((clinic) => {
        clinic.boxes.forEach((box) => {
          ret[box.id] = clinic;
        });
      });
      return ret;
    },
    loadAppointments() {
      if (!this.is_loading) {
        this.is_loading = true;
        axios
          .get(`/customer/${this.customer.id}/appointments`)
          .then((response) => {
            this.appointments = response.data.appointments;
            this.next_appointment = response.data.next_appointment || {};
            this.clinics = response.data.clinics;
            this.pending_treatments = response.data.pending_treatments;
            this.box_to_clinic = this.mapBoxesToClinics(this.clinics);
          })
          .catch((error) => {
            console.log("[ERR] loadAppointments ", error);
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    newAppointment() {
      this.$refs.showapp.showCustomerNew(this.customer);
    },
    getAppointmentBox(app) {
      let clinic = this.box_to_clinic[app.box_id];
      if (!clinic) return null;
      let found = clinic.boxes.filter((box) => {
        return box.id == app.box_id;
      });
      return found.length > 0 ? found[0] : null;
    },
    editAppointment(app) {
      if (app.deleted_at) {
        this.errorwindow.show('Error', 'Esta cita fue borrada, no se puede editar');
        return;
      }


      if (!this.isCurrentClinic(app)) {
        this.errorwindow.show('Error', 'Esta cita pertenece a otro centro. Por favor cambia de centro para poder editarla');
        return;
      }

      app.customer = this.customer;
      this.$refs.showapp.showEdit(
        app,
        undefined,
        undefined,
        this.getAppointmentBox(app)
      );
    },
    sendEnroll() {
      this.$refs.enroll.show();
    },
    sendPending() {
      let lines = [];
      let now = moment();
      lines.unshift(this.pending_msg_footer);

      this.appointments.forEach((app) => {

        // Discard appointments
        if (app.status != 'pending' ||
          app.deleted_at !== null ||
          app.is_urgent ||
          app.disable_auto_messaging) {
          return;
        }

        const from = moment(app.date_from);
        const clinic = this.box_to_clinic[app.box_id] || null;
        const clinic_name = clinic ? clinic.name : '';
        const doctor = this.doctor_names[app.doctor_id] || null;

        if (from >= now) {
          let line = from.format("[ · El] dddd DD/MM/YYYY [a las] HH:mm");
          line = line + ' en ' + clinic_name;
          if (doctor) {
            line = ' ' + line + ' con ' + doctor;
          }
          lines.unshift(line);
        }
      });

      lines.unshift(this.pending_msg_header);
      let message = lines.join("\n");

      let number = String(this.customer.phone)
        .replace(" ", "")
        .replace("-", "")
        .replace("+", "")
        .replace("(", "")
        .replace(")", "");

      if (!this.customer.phone.includes('+')) {
        number = '34' + number;
      }

      let text = encodeURIComponent(message);
      let url = `https://wa.me/${number}?text=${text}`;

      if (this.clinic.config.use_wa_app) {
        url = `whatsapp://send?phone=${number}&text=${text}`;
      }

      window.open(url, "_blank");
    },
  },
  mounted() {
    this.loadAppointments();
  },
};
</script>

<style lang="scss" scoped>
.customer-edit-appointments {
  margin-top: 19px;

  &__header {
    margin-bottom: 30px;
  }

  .customer-edit-appointments-list {
    max-height: 60vh;
    overflow-y: scroll;
    overflow-x: hidden;

    .customer-edit-appointment {
      border: 2px var(--theme-grey-disabled) solid;
      border-radius: 5px;
      padding: 19px;
      margin-bottom: 10px;

      &__document {
        color: var(--theme-color);
        text-decoration: none;

        small {
          font-size: 12px;
          font-weight: 500;
        }
      }

      label {
        color: var(--theme-grey);
        font-size: 15px;
        font-weight: 500;
      }

      label+label {
        margin-left: 15px;
      }

      p {
        margin-bottom: 0;
        min-height: 24px;
      }

      &.pending {
        background-color: var(--theme-grey-bg);
      }
    }
  }
}
</style>
